import { render, staticRenderFns } from "./dynamicDetail.vue?vue&type=template&id=228e67fc&scoped=true&"
import script from "./dynamicDetail.vue?vue&type=script&lang=js&"
export * from "./dynamicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e67fc",
  null
  
)

export default component.exports